import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  dateForList,
  dateForListWithHours,
} from "../../../../constants/dataFormat";
import {
  CNPJFormater,
  CPFFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import InfoCardsDetalhamento from "../../boletos/defaultComponents/InfoCardsDetalhamento";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function ModalDetailVendaBoleto({
  isOpen,
  setIsOpen,
  item,
}: any) {
  const finalRef = React.useRef(null);
  const colors = useRecoilState(customColors)[0];

  const onClose = () => {
    setIsOpen(false);
  };

  const [objetoPagamento, setObjetoPagamento] = useState<any>();
  // const [objetoSolicitante, setObjetoSolicitante] = useState<any>();
  const [objetoBeneficiario, setObjetoBeneficiario] = useState<any>();

  useEffect(() => {
    if (item && Object.keys(item).length !== 0) {
      const gerarObjetoPagamento = () => {
        return [
          {
            titulo: "Número da Transação: ",
            valor: item && item.numeroTransacao,
          },
          {
            titulo: "Modo de Pagamento: ",
            valor: item && item.nomeModoPgto,
          },
          {
            titulo: "Data de Criação: ",
            valor: item && moment(item.dataCriacao).format(dateForListWithHours),
          },
          {
            titulo: "Data do Vencimento: ",
            valor: item && moment(item.dataExpiracao).format(dateForList),
          },
          // {
          //   titulo: "Valor Nominal: ",
          //   valor: item && ToLocaleFormat(item.valorNominal),
          // },
          {
            titulo: "Valor Pagamento: ",
            valor: item && ToLocaleFormat(item.valorLiquido),
          },
        ];
      };

      // const gerarObjetoSolicitante = () => {
      //   return [
      //     {
      //       titulo: "Nome do Solicitante: ",
      //       valor:
      //         item && item?.cliente?.isCnpj === true
      //           ? `${item?.cliente?.razaoSocial}`
      //           : `${item.cliente.nome} ${item.cliente.sobrenome}`,
      //     },
      //     {
      //       titulo: "CPF/CNPJ do Solicitante: ",
      //       valor:
      //         item && item.cliente.isCnpj === true
      //           ? CNPJFormater(item.cliente.cnpj)
      //           : CPFFormater(item.cliente.cnpj),
      //     },
      //   ];
      // };

      const gerarObjetoBeneficiario = () => {
        return [
          // {
          //   titulo: "Nome do Beneficiário: ",
          //   valor: item.nomeBeneficiario,
          // },
          {
            titulo: "CPF/CNPJ do Beneficiário: ",
            valor:
              item && item.cnpj.length === 11
                ? CPFFormater(item.cnpj)
                : CNPJFormater(item.cnpj),
          },
        ];
      };
      // setObjetoSolicitante(gerarObjetoSolicitante());
      setObjetoBeneficiario(gerarObjetoBeneficiario());
      setObjetoPagamento(gerarObjetoPagamento());
    }

  }, [item]);

  function AbrirBoleto (url: any) {
    const a = document.createElement("a");
    a.href = url;
    a.target="_blank"
    a.click();
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"4xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>
                Detalhamento da Solicitação de Pagamento
              </Text>
            </Flex>
          </ModalHeader>
          {item ? (
            <ModalBody
              display={"flex"}
              flexDir="column"
              justifyContent={"space-between"}
              alignItems="center"
            >
              <Flex
                w={"85%"}
                alignItems={"flex-start"}
                minHeight={"200px"}
                height={"fit-content"}
                border={"2px solid #c4c4c4"}
                flexDir={"column"}
                shadow={"md"}
                borderRadius={"6px"}
                px={4}
                py={4}
              >
                <InfoCardsDetalhamento
                  title={"Informações da Solicitação de Pagamento"}
                  array={objetoPagamento}
                />
                {/* <Divider variant="dashed"></Divider> */}
                {/* <InfoCardsDetalhamento
                  title={"Informações do Beneficiário"}
                  array={objetoBeneficiario}
                /> */}
              </Flex>
              <Button
                bgColor={colors.BLUEMONEDDBUTTONS}
                color={"white"}
                my={2}
                onClick={() => AbrirBoleto(item.urlBoleto)}
              >
                Abrir Boleto
              </Button>
              <Flex
                w={"85%"}
                alignItems={"flex-start"}
                // minHeight={"250px"}
                // height={"40%"}
                border={"2px solid #c4c4c4"}
                flexDir={"column"}
                shadow={"md"}
                borderRadius={"6px"}
                px={1}
                py={1}
              >
                <iframe
                  src={item.urlBoleto}
                  width={"100%"}
                  height={"350px"}
                />
              </Flex>
              
            </ModalBody>
          ) : (
            <></>
          )} 
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={colors.GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
